import React, { useState } from "react";
import AdminChatList from "./AdminChatList";
import AdminChatScreen from "./AdminChatScreen";

const AdminPage = () => {
  const [selectedChat, setSelectedChat] = useState(null);

  return selectedChat ? (
    <AdminChatScreen 
      chatId={selectedChat.id} 
      customerName={selectedChat.customerName}
      onBack={() => setSelectedChat(null)}
    />
  ) : (
    <AdminChatList onSelectChat={(id, name) => setSelectedChat({ id, customerName: name })} />
  );
};

export default AdminPage;
